import { render, staticRenderFns } from "./QuestionarioProntoAtendimento.vue?vue&type=template&id=44001848&scoped=true"
import script from "./QuestionarioProntoAtendimento.vue?vue&type=script&lang=js"
export * from "./QuestionarioProntoAtendimento.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioProntoAtendimento.vue?vue&type=style&index=0&id=44001848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44001848",
  null
  
)

export default component.exports